import { useShareDeleted, UseShareDeletedProps } from './useShareDeleted'
import { useShareRestored, UseShareRestoredProps } from './useShareRestored'

import {
  useEmptiedWorkspaceTrash,
  UseEmptiedWorkspaceTrashProps,
} from './useEmptiedWorkspaceTrash'
import {
  useShareDeletedPermanently,
  UseShareDeletedPermanentlyProps,
} from './useDeletedSharePermanently'

export interface UseShareSubscriptionsProps
  extends UseShareDeletedProps,
    UseShareRestoredProps,
    UseEmptiedWorkspaceTrashProps,
    UseShareDeletedPermanentlyProps {}

export const useShareSubscriptions = (
  props: UseShareSubscriptionsProps = {}
) => {
  const {
    onShareDeleted,
    onShareRestored,
    onEmptiedWorkspaceTrash,
    onDeletedSharePermanently,
  } = props

  useShareDeleted({ onShareDeleted })
  useShareRestored({ onShareRestored })
  useEmptiedWorkspaceTrash({ onEmptiedWorkspaceTrash })
  useShareDeletedPermanently({ onDeletedSharePermanently })
}
